import {
  FolderGit,
  Package,
  Bolt,
  Boxes,
  Save,
  Tag,
  Truck,
  Network,
  Workflow,
  FolderTree,
  TextSearch,
  Factory,
  Building2,
  TableProperties,
  Stethoscope,
  Search,
  MessageSquare,
  MessagesSquare,
  MessageSquareDot,
  MessageCircleWarning,
  MessageCircleQuestion,
  Sparkles,
  SwatchBook,
  TriangleAlert,
  ShieldX,
  User,
  Wrench,
  Layers,
  FileText,
  TypeIcon as type,
  LucideIcon,
  SquarePen,
  RectangleEllipsis,
  TicketPlus,
  Import,
} from 'lucide-react'

import { Google } from '@sourcepilot/ui/framework/ui/atoms/icons/Google';
import { Microsoft } from '@sourcepilot/ui/framework/ui/atoms/icons/Microsoft';
import { GitHub } from '@sourcepilot/ui/framework/ui/atoms/icons/Github';

// Make this a global map of LucideIcons?
export const iconMap: Record<string, LucideIcon | React.ComponentType<any>> = {
  // workspace nodes (MUST match db Node labels, lowercase)
  'workspace': FolderGit,
  'product': Package,
  'breakdown': Network,
  'bom': FolderTree,
  'module': Boxes,
  // 'assembly': Network,
  'components': FolderTree,
  'part': FileText, // componentSpec renamed to part
  'component': Bolt,
  'requirementset': TableProperties,
  'requirement': Tag,
  'chat': MessageSquare,
  'thread': MessagesSquare,
  'step': MessageSquareDot,
  'sparkles': Sparkles,
  'message-square': MessageSquare,

  // api nodes (MUST match db Node labels, lowercase)
  'supplier': Truck,
  'manufacturer': Wrench,
  'organisation': Building2,
  'user': User,
  // scaffolded plural routes (/organisations/[id], /users/[id]) seed
  // Shell tabs with the path segment as contentType — same icons as
  // their legacy singular counterparts above
  'organisations': Building2,
  'users': User,
  'reference': TextSearch,
  'industry': Factory,

  // thread/task scopes  (MUST match <ThreadContextScope> enum, lowercase)
  'componentsearch': Search,
  'analysis': Stethoscope,
  'suggestion': MessageCircleQuestion,
  'choices': SwatchBook,
  'mapping': Import,
  'inputrequired': MessageCircleWarning,
  'inputerror': ShieldX,
  'inputWarning': TriangleAlert,

  'edit': SquarePen,
  'save': Save,

  // others
  'addTag': TicketPlus,
  'any': RectangleEllipsis,
  'google': Google,
  'microsoft': Microsoft,
  'github': GitHub,
}
